import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProfileResponse, UserResponse } from '../../utils/types';

type State = {
    token: string | undefined | null,
    refreshToken: string | undefined | null,
    accessExpiry: Date | undefined | null,
    user: UserResponse | undefined | null,
    profile: ProfileResponse | null,
}

const initialState: State = {
    token: null,
    refreshToken: null,
    accessExpiry: null,
    user: null,
    profile: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthTokens(
            state: State,
            action: PayloadAction<{ token: string | undefined | null, accessExpiry: Date | undefined | null, refreshToken: string | undefined | null}>
        ) {
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
            state.accessExpiry = action.payload.accessExpiry;
        },
        setUser(state: State, action: PayloadAction<UserResponse>) {
            state.user = action.payload;
        },
        setProfile(state: State, action: PayloadAction<ProfileResponse | null>) {
            state.profile = action.payload;
        },
        setLogout(state: State) {
            state.user = null;
            state.profile = null;
            state.token = null;
            state.refreshToken = null;
            state.accessExpiry = null;
        },
    },
});

export default authSlice;
